import { objectSpread2 as _objectSpread2, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import React, { useMemo } from 'react';
import { composeRenderProps, Group } from 'react-aria-components';
import { useComponentTheme } from '../../../theme/theme.context.esm.js';

function FieldGroup(props) {
  var theme = useComponentTheme('FieldGroup');
  var canShrink = props.canShrink,
    _props$className = props.className,
    _className = _props$className === void 0 ? '' : _props$className,
    alignItems = props.alignItems,
    fullHeight = props.fullHeight,
    fullWidth = props.fullWidth,
    gap = props.gap,
    gapCol = props.gapCol,
    gapRow = props.gapRow,
    inline = props.inline,
    justify = props.justify,
    padding = props.padding,
    paddingX = props.paddingX,
    paddingY = props.paddingY,
    _props$radius = props.radius,
    radius = _props$radius === void 0 ? 'sm' : _props$radius,
    _props$size = props.size,
    size = _props$size === void 0 ? 'std' : _props$size,
    stretch = props.stretch;
  var classes = useMemo(function () {
    return composeRenderProps(_className, function (className, renderProps) {
      var classes = theme(_objectSpread2(_objectSpread2({}, renderProps), {}, {
        canShrink: canShrink,
        className: className,
        alignItems: alignItems,
        fullHeight: fullHeight,
        fullWidth: fullWidth,
        gap: gap,
        gapCol: gapCol,
        gapRow: gapRow,
        inline: inline,
        justify: justify,
        padding: padding,
        paddingX: paddingX,
        paddingY: paddingY,
        radius: radius,
        size: size,
        stretch: stretch
      }));
      return "csg-tw-field-group ".concat(classes);
    });
  }, [_className, theme, canShrink, alignItems, fullHeight, fullWidth, gap, gapCol, gapRow, inline, justify, padding, paddingX, paddingY, radius, size, stretch]);
  return /*#__PURE__*/React.createElement(Group, _extends({}, props, {
    className: classes
  }));
}

export { FieldGroup };
//# sourceMappingURL=field-group.esm.js.map
